import { createGlobalStyle, css } from 'styled-components';
import { HeaderFilterButton } from '../components/TableColumnHeaderActions/styles';
import { GlobalSearchContainer } from '../components/TableHeader/styles';
import { PaginationWrapper } from '../components/TablePagination/style';
import { ActionToolbarContainer } from '../../ActionToolbar';

export const PrintStyles = createGlobalStyle<{ enableRowSelection: boolean }>`
  @media print {
        ${GlobalSearchContainer},
        ${ActionToolbarContainer},
        ${HeaderFilterButton},
        ${PaginationWrapper} {
            display: none;
        }
        ${({ enableRowSelection }) =>
            enableRowSelection &&
            css`
                thead th,
                tbody tr td {
                    &:first-child {
                        display: none;
                    }
                }
            `}
    }
`;
